import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class UpdateUserToLilyFree {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    handle(userId, subscriptionId) {
        const url = prepareUrl(ApiEndpoints['users.preferences.dislikes-lilies.store'], [userId]);

        return this.apiService.patch(url, { dislikes_lilies: 1, subscription_id: subscriptionId, no_lily_free_option: 1 });
    }
}
